import type { QueryHashRef } from '../../hooks/gql';
import { sha256 } from './sha256';

export const createPersistedQuery = async (query: string) => {
  const sha256Hash = await sha256(query);

  return sha256Hash
    ? {
        version: 1,
        sha256Hash,
      }
    : null;
};

export const resolvePersistedQuery = async (queryHashRef: QueryHashRef) => {
  const sha256Hash = queryHashRef.current.hash || (await queryHashRef.current.hashPromise);

  return sha256Hash
    ? {
        version: 1,
        sha256Hash,
      }
    : null;
};
